import client from './client';

export const postCandidateSupportChat = (payload) =>
  client.post('/api/candidate-support/chat', payload);
